import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { ResizeableType, WBComponent } from "./WBComponent";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { defaultDropList } from "../Data/WBComponentDefaults";
import { AttributeDefinition, AttributeInputType, sharedComponentAttributes } from "../Data/WBData";
import WebDesigner from "../WebDesigner";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";


export default class BusinessPackages extends WBComponent {
    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessPackages;
        this.displayName = "Packages";
        this.dropList = defaultDropList;
        this.primaryEditAttributes = [
            componentAttributeTypes.multiLocation, 
            componentAttributeTypes.layoutId,
            componentAttributeTypes.packageFilter,
            "panelRadius", 
            "panelPadding",
            "panelLayoutPadding"
        ];
        this.colorFields = ["serviceTitleColor","detailColor","descColor", "panelColor","panelBorder","color","backgroundColor"];
        this.editList = [...this.colorFields,...this.primaryEditAttributes, componentAttributeTypes.packageFilter, componentAttributeTypes.multiLocation, componentAttributeTypes.alloWMultiLocalationBooking, componentAttributeTypes.layoutId, ...CreateAttributeList(true, true, true, true, false, false,false), "panelPadding", "panelLayoutPadding"];
        this.resizeType = ResizeableType.All;
        
        this.vagaroLink = "https://www.vagaro.com/ShopOwner/CustomPackageManagement.aspx"
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 640 512"><path d="M80.4 49.5L320 77.2 559.6 49.5c14.1-1.6 27.5 6.2 33.1 19.2l32 74.7c9.8 22.9-3.5 49.1-27.8 54.7L437.8 234.8c-18.9 4.4-38.6-3.1-49.9-18.9L320 120.9l-67.9 95.1c-11.3 15.8-30.9 23.2-49.9 18.9L43 198c-24.3-5.6-37.6-31.8-27.8-54.7l32-74.7c5.6-13 19-20.8 33.1-19.2zM76.7 81.3l-32 74.7c-2 4.6 .7 9.8 5.6 10.9l159.2 36.7c6.3 1.5 12.9-1 16.6-6.3l65.1-91.2L76.7 81.3zM544 236.7l32-9.1v151c0 22-15 41.2-36.4 46.6l-208 52c-7.6 1.9-15.6 1.9-23.3 0l-208-52C79 419.7 64 400.5 64 378.5v-151l32 9.1V378.5c0 7.3 5 13.7 12.1 15.5L304 443V208c0-8.8 7.2-16 16-16s16 7.2 16 16V443l195.9-49c7.1-1.8 12.1-8.2 12.1-15.5V236.7zM348.8 106.1l65.1 91.2c3.8 5.3 10.3 7.7 16.6 6.3l159.2-36.7c4.9-1.1 7.5-6.4 5.6-10.9l-32-74.7L348.8 106.1z"/></svg>  
        this.cssDefinitions =[
            new NodeCSSClassDefinition(".service-panel",
            [
                {key:"panelColor",cssProperty:"background",default:""},
                {key:"panelRadius",cssProperty:"border-radius",default:""},
                {key:"panelPadding",cssProperty:"padding",default:""},
                {key:"panelBorder",cssProperty:"border-color",default:""}
        
             ]) ,
             new NodeCSSClassDefinition(".b-panel-container",
             [
                {key:"panelLayoutPadding", cssProperty:"padding", default:"8px"},
                {key:"maxWidth",cssProperty:"max-width",default:"1200px"},
                {key:"margin",cssProperty:"margin",default:"0 auto"},
              ]),
              new NodeCSSClassDefinition(".service-title",
              [
                  {key:"serviceTitleColor",cssProperty:"color",default:"",stencil:"transparent"},
         
                  
               ]),
               
               new NodeCSSClassDefinition(".service-description",
               [
                   {key:"descColor",cssProperty:"color",default:"",stencil:"transparent"},
          
                   
                ]),
                new NodeCSSClassDefinition(".service-pricing",
                [
                    {key:"detailColor",cssProperty:"color",default:"",stencil:"transparent"},
           
                    
                 ]),
                 new NodeCSSClassDefinition(".s-other:not(.promo-container) ",
                 [
                     {key:"detailColor",cssProperty:"color",default:"",stencil:"transparent"},
            
                     
                  ]),
    
        ];
    
    }
        

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }


    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            sharedComponentAttributes.contentSpacing,
            sharedComponentAttributes.panelRadius,
            sharedComponentAttributes.panelSpacing,
            new AttributeDefinition(componentAttributeTypes.layoutId, "Layout", componentAttributeTypes.layoutId, AttributeInputType.SelectField, [
                { label: "Default", value: "1" },
                { label: "Horizontal", value: "2" },
                { label: "Cards", value: "3" },
            ]),
            new AttributeDefinition("panelColor", "Panel Color", "", AttributeInputType.ColorField),
           
            new AttributeDefinition("serviceTitleColor", "Title", "", AttributeInputType.ColorField),
            new AttributeDefinition("detailColor", "Price", "", AttributeInputType.ColorField),
            new AttributeDefinition("descColor", "Description", "", AttributeInputType.ColorField),
            new AttributeDefinition(componentAttributeTypes.packageFilter, "Package Filter", "", AttributeInputType.PackageSelector)
        ]
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes("max-100 w-full resizable-container scrollable nice-scroll vb-control", component, screenSize, isEditor);
        const layout = getNodeComponentAttributeValue(component, componentAttributeTypes.layoutId, "1");
        const filters = getNodeComponentAttributeValue(component, componentAttributeTypes.packageFilter, "")

        if (!isEditor) {
            return <BusinessPlaceHolder node={component} inFilter={filters} dataKey="packages" layout={layout} classNames={atts.className} />
        }

        return (
            <>
                <style>
                    {super.GetComponentGlobalCSS(component, isEditor)}
                </style>
                <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
               
                    <GenericBusinessControl key={bid} filters={filters} bLocationId={bid} layout={layout} dataKey="packages" node={component} userContext={siteData} />
                  
                </div>
            </>
        )
    }
}



